import type { ReactNode } from 'react';

/** Native radio covers the card; disclosure controls remain independent above it. */
export function SavedIdeaCard({
  id,
  title,
  selected,
  disabled,
  onSelect,
  children,
}: {
  id: string;
  title: string;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
  children: ReactNode;
}) {
  return (
    <article className={`mj-ws-card mj-ws-idea-card${selected ? ' is-selected' : ''}`}>
      <input
        className="mj-ws-idea-radio"
        type="radio"
        name="saved-idea"
        value={id}
        aria-label={title}
        checked={selected}
        disabled={disabled}
        onChange={onSelect}
      />
      <span className="mj-ws-idea-bullet" aria-hidden="true" />
      {children}
    </article>
  );
}
